import { NavLink } from "react-router-dom";
import styles from "./mobileSuperAdminSideBar.module.scss";
import { SUPER_ADMIN_PANEL_ROUTES } from "@source/utils/utils";
import { observer } from "mobx-react-lite";
import openMenuBack from "@assets/icons/openMenuBack.svg";
import { useEffect, useState } from "react";

const MobileSuperAdminSideBar = observer((props: MobileSuperAdminSideBarProps) => {
  const { isOpen, onClose } = props;
  const [animationState, setAnimationState] = useState<'entering' | 'entered' | 'exiting'>('entering');

  // Animation effect - trigger entering animation on mount
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        setAnimationState('entered');
      }, 10);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleClose = () => {
    setAnimationState('exiting');
    setTimeout(() => {
      onClose();
    }, 150);
  };

  const handleNavClick = () => {
    handleClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.mobileSideBar}>
        {/* Header with close button */}
        <div className={styles.header}>
          <div className={styles.closeMenu} onClick={handleClose}>
            <img className={styles.toggle__btn} src={openMenuBack} alt="close menu" />
            <span className={styles.closeMenuText}>Hide menu</span>
          </div>
        </div>

        {/* Navigation */}
        <div className={`${styles.navContainer} ${animationState === 'entered' ? styles.entering : animationState === 'exiting' ? styles.exiting : ''}`}>
          <div className={styles.nav}>
            <NavLink
              to={SUPER_ADMIN_PANEL_ROUTES.Organisations}
              className={styles.navItem}
              activeClassName={styles.navItemActive}
              onClick={handleNavClick}
            >
              Organisations
            </NavLink>

            <NavLink
              to={SUPER_ADMIN_PANEL_ROUTES.Residents}
              className={styles.navItem}
              activeClassName={styles.navItemActive}
              onClick={handleNavClick}
            >
              Residents
            </NavLink>

            <NavLink
              to={SUPER_ADMIN_PANEL_ROUTES.FamilyMembers}
              className={styles.navItem}
              activeClassName={styles.navItemActive}
              onClick={handleNavClick}
            >
              Family members
            </NavLink>

            <NavLink
              to={SUPER_ADMIN_PANEL_ROUTES.Employees}
              className={styles.navItem}
              activeClassName={styles.navItemActive}
              onClick={handleNavClick}
            >
              Staff
            </NavLink>

            <NavLink
              to={SUPER_ADMIN_PANEL_ROUTES.NursingHomes}
              className={styles.navItem}
              activeClassName={styles.navItemActive}
              onClick={handleNavClick}
            >
              Homes
            </NavLink>

            <NavLink
              to={SUPER_ADMIN_PANEL_ROUTES.Statistics}
              className={styles.navItem}
              activeClassName={styles.navItemActive}
              onClick={handleNavClick}
            >
              Statistics
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
});

export default MobileSuperAdminSideBar;

interface MobileSuperAdminSideBarProps {
  isOpen: boolean;
  onClose: () => void;
}
